<template>
  <b-modal id="modal-impressao-certidao"
           ref="modal-impressao-certidao"
           class="impressao--modal"
           :content-class="zoomClass"
           size="xl">
    <!-- frestes que serão mostradadas no modal de acordo com o tipo -->
    <frente-impressao-obito v-show="!certidaoVerso && tipo=='obito'"
                            :data="impressao" />

    <frente-impressao-nascimento v-show="!certidaoVerso && tipo=='nascimento'"
                                 :data="impressao" />

    <FrenteImpressaoCasamento v-show="!certidaoVerso && tipo=='casamento' && !!visualizarFrenteImpressao"
                              :prop-casamento="impressao" />

    <object v-if="tipo=='habilitacao' && propFilePreview != null"
            class=""
            style="height: 296mm; width: 80vh;"
            :data="`${propFilePreview }#toolbar=0&navpanes=0&scrollbar=0`"
            type="application/pdf">
      <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
    </object>

    <verso-impressao v-show="certidaoVerso && tipo != 'habilitacao'"
                     :prop-tipo="tipo"
                     :data="impressao" />


    <template v-slot:modal-header>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            :disabled="zoom < 1"
            @click="zoom--">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomMinus" />
          </b-button>
          <b-button
            size="sm"
            class="ml-2 mr-2"
            variant="primary"
            :disabled="zoom > 1"
            @click="zoom++">
            <icon-svg class="impressao_documento--icon icons--white icon--xs"
                      icon="zoomPlus" />
          </b-button>
          <b-button
            v-if="!certidaoVerso && tipo != 'habilitacao'"
            variant="secondary"
            size="sm"
            @click="certidaoVerso = !certidaoVerso">
            Visualizar Verso
          </b-button>
          <b-button
            v-if="certidaoVerso && tipo != 'habilitacao'"
            variant="secondary"
            size="sm"
            @click="certidaoVerso = !certidaoVerso">
            Visualizar Frente
          </b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="default"
            @click="$bvModal.hide('modal-impressao-certidao')">
            <icon-svg class="impressao_documento--icon icon--xs"
                      icon="close" />
          </b-button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="w-100">
        <div class="float-right">
          <b-button
            size="sm"
            variant="default"
            class="mr-2"
            @click="$bvModal.hide('modal-impressao-certidao')">
            Voltar
          </b-button>
          <b-button
            v-if="!certidaoVerso && tipo != 'habilitacao'"
            variant="secondary"
            size="sm"
            @click="certidaoVerso = !certidaoVerso">
            Visualizar Verso
          </b-button>
          <b-button
            v-if="certidaoVerso && tipo != 'habilitacao'"
            variant="secondary"
            size="sm"
            @click="certidaoVerso = !certidaoVerso">
            Visualizar Frente
          </b-button>
          <!--<b-button
            variant="secondary"
            size="sm"
            class="ml-1"
            @click="imprimir()">
            Imprimir
          </b-button>-->
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
  /* components */
  import FrenteImpressaoObito from "./Templates/FrenteImpressaoObito"
  import FrenteImpressaoNascimento from "./Templates/FrenteImpressaoNascimento"
  import FrenteImpressaoCasamento from "./Templates/FrenteImpressaoCasamento"
  import VersoImpressao from "./Templates/VersoImpressao"

  /* constants */
  import { getOrgaoEmissor } from "@/constants/documentosPessoais"

  /* services */
  import EnderecosService from "@/services/Enderecos"

  export default {
    name: "ModalCertidao",
    components: {
      VersoImpressao,
      FrenteImpressaoObito,
      FrenteImpressaoNascimento,
      FrenteImpressaoCasamento
    },
    props: {
      data: Object,
      tipo: String,
      propFilePreview: String
    },
    data () {
      return {
        optionsOrgaoEmissor: [],
        certidaoVerso: false,
        impressao: {},
        zoom: 0,
        visualizarFrenteImpressao: false
      }
    },
    computed: {
      zoomClass: function () {
        let className = ''

        switch (this.zoom) {
        case 2:
          className = 'modalZoom--2'
          break
        case 1:
          className = 'modalZoom--1'
          break
        case 0:
          className = ''
          break
        }

        return className
      }
    },
    watch: {
      data () {
        this.impressao = {...this.data}
        this.anotacoes()
      },
      'data.emolumentos': function () {
        this.impressao = { ...this.data }
        this.impressao && !!this.impressao.ordemServicoSelected ? this.destinatariosAdapter(this.impressao) : ''
      }
    },
    beforeMount () {
      this.impressao = {...this.data}
      this.anotacoes()
      this.impressao && !!this.impressao.ordemServicoSelected ? this.destinatariosAdapter(this.impressao) : ''
    },
    methods: {
      anotacoes () {
        this.visualizarFrenteImpressao = this.data.dados ? true : false
        this.impressao.documentos = this.data.anotacoes

        this.impressao.documentos.forEach(async documento => {
          if (documento.codigo_orgao_emissor) {
            const orgao = await getOrgaoEmissor()
            const orgaoSelect = orgao.filter(orgao => orgao.codigo == documento.codigo_orgao_emissor)
            documento.orgao_emissor = orgaoSelect[0].descricao
          }
          if (documento.uf_emissor) {
            this.states = await EnderecosService.getStates()
            const stateSelect = this.states.filter(uf => uf.codigo == documento.uf_emissor)
            documento.uf = stateSelect[0].uf
          }

          if (documento.tipo_documento) {
            documento.tipo = this.getTipo(documento.tipo_documento)
          }
        })

        if (this.impressao.registro && this.impressao.registro.pessoas) {
          this.impressao.registro.pessoas.forEach( async pessoa => {
            for (const anotacao of pessoa.anotacoes) {
              if (anotacao.codigo_orgao_emissor) {
                const orgao = await getOrgaoEmissor()
                const orgaoSelect = orgao.filter(orgao => orgao.codigo == anotacao.codigo_orgao_emissor)
                anotacao.orgao_emissor = orgaoSelect[0].descricao
              }
              if (anotacao.uf_emissor) {
                this.states = await EnderecosService.getStates()
                const stateSelect = this.states.filter(uf => uf.codigo == anotacao.uf_emissor)
                anotacao.uf = stateSelect[0].uf
              }

              if (anotacao.tipo_documento) {
                anotacao.tipo = this.getTipo(anotacao.tipo_documento)
              }
            }

          })
        }
      },
      imprimir () {
        this.$emit('onImprimir')
      },
      getTipo (tipo) {
        switch (tipo) {
        case 'rg':
          return 'RG'
        case 'pis_nis':
          return 'PIS/NIS'
        case 'passaporte':
          return 'PASSAPORTE'
        case 'cns':
          return 'CARTÃO NACIONAL DE SAÚDE'
        case 'titulo':
          return 'TITULO DE ELEITOR'
        case 'cep':
          return 'CEP RESIDENCIAL'
        case 'sanguineo':
          return 'GRUPO SANGUÍNEO'
        case 'ctps':
          return 'CARTEIRA DE TRABALHO E PREVIDÊNCIA SOCIAL'
        case 'reservista':
          return 'RESERVISTA'
        case 'cnh':
          return 'CARTEIRA NACIONAL DE HABILITAÇÃO'
        default:
          break
        }
      },

      destinatariosAdapter (data) {
        // Método utilizado para filtrar exibição dos destinatarios com base no tipo de custa
        const custaRegistroCivil = data.ordemServicoSelected.itens.find((item) => item.custa.tipo == 'REGISTRO_CIVIL')
        const custaAtosNotariais = data.ordemServicoSelected.itens.find((item) => item.custa.tipo != 'REGISTRO_CIVIL')

        let filtrados = []
        this.impressao.emolumentosFiltrados = []

        if (!!custaRegistroCivil && !!custaAtosNotariais) {
          filtrados = data.emolumentos.filter((emolumento) => ['MUNICIPIO'].indexOf(emolumento.destino) < 0)

          // Possivel melhoria: 
          // const ipesp = data.emolumentos.find((emolumento) => emolumento.destino == 'IPESP')
          // const secFaz = data.emolumentos.find((emolumento) => emolumento.destino == 'A SEC. FAZ.')
          // const valorSecFaz = ipesp.valor + secFaz.valor
          // this.impressao.emolumentosFiltrados.push({destino: 'A SEC. FAZ.', valor: valorSecFaz}) // 'A SEC. FAZ.', 'IPESP'
        }
        else if (!!custaRegistroCivil && !custaAtosNotariais) {
          //Apenas Registro Civil
          filtrados = data.emolumentos.filter((emolumento) => ['TABELIAO', 'ESTADO', 'MINISTERIO PUBLICO', 'REGISTRO CIVIL', 'TRIBUNAL JUSTICA', 'SANTA CASA', 'IPESP', 'MUNICIPIO'].indexOf(emolumento.destino) < 0)
        }
        else {
          //Apenas Atos Notariais
          filtrados = data.emolumentos.filter((emolumento) => ['AO OFICIAL', 'A SEC. FAZ.'].indexOf(emolumento.destino) < 0)
        }

        // Por fim tratamos o nome dos destinatários que foram filtrados:
        if (!!filtrados) {
          filtrados.forEach((emolumento) => {
            switch (emolumento.destino) {
            case 'AO OFICIAL':
              !!custaRegistroCivil ? this.impressao.emolumentosFiltrados.push({destino: 'Ao oficial', valor: emolumento.valor}) : ''
              break

            case 'A SEC. FAZ.':
              !!custaRegistroCivil ? this.impressao.emolumentosFiltrados.push({destino: 'A Sec. Faz', valor: emolumento.valor}) : ''
              break

            case 'ESTADO':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Estado', valor: emolumento.valor}) : ''
              break

            case 'ISS':
              this.impressao.emolumentosFiltrados.push({destino: 'ISS', valor: emolumento.valor})
              break

            case 'REGISTRO CIVIL':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Registro Civil', valor: emolumento.valor}) : ''
              break

            case 'MINISTERIO PUBLICO':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Ministério Publico', valor: emolumento.valor}) : ''
              break

            case 'TRIBUNAL JUSTICA':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Tribunal de Justiça', valor: emolumento.valor}) : ''
              break

            case 'SANTA CASA':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Santa Casa', valor: emolumento.valor}) : ''
              break

            case 'TABELIAO':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'Tabelião', valor: emolumento.valor}) : ''
              break

            case 'IPESP':
              !!custaAtosNotariais ? this.impressao.emolumentosFiltrados.push({destino: 'IPESP', valor: emolumento.valor}) : ''
              break

            case 'Total':
              this.impressao.emolumentosFiltrados.push({destino: 'Total',valor: emolumento.valor})
              break
            }
          })
        }



      }
    }
  }
</script>

<style lang="scss">
  @import '../../../../../../scss/_utilities/exports';
  @import "../../../../../../scss/_components/modals";
  @import "../../../../../../scss/_components/_modalCertidao.scss";
</style>
